import { Component, OnDestroy, OnInit } from "@angular/core";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { ActivatedRoute } from "@angular/router";
import { NodeService } from "src/app/services/node.service";
import { User } from "src/app/entities/users";
import Base64 from "crypto-js/enc-base64";
import Utf8 from "crypto-js/enc-utf8";

@Component({
  selector: "app-recover",
  templateUrl: "./recover.component.html",
  styleUrls: ["./recover.component.scss"],
})
export class RecoverComponent implements OnInit, OnDestroy {
  loading = true;
  codeValid = false;
  resetError: string | null = null;
  resetSaveError: string | null = null;
  resetSuccess = false;

  private code = "";
  private destroy$ = new Subject<void>();

  constructor(
    private route: ActivatedRoute,
    private node: NodeService,
  ) {}

  ngOnInit(): void {
    this.code = this.route.snapshot.params['code'] || "";
    this.validateCode();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onResetPassword(password: string): void {
    this.resetSaveError = null;
    const pwd = Base64.stringify(
      Utf8.parse(password)
    );

    this.node.resetPassword({ code: this.code, pwd }).pipe(takeUntil(this.destroy$)).subscribe({
      next: () => {
        this.resetSuccess = true;
      },
      error: (err: { detail?: string }) => {
        this.resetSaveError = typeof err?.detail === "string"
          ? err.detail
          : "Si è verificato un errore durante il salvataggio. Riprova.";
      },
    });
  }

  private validateCode(): void {
    const formData = { field: "temp_code", code: this.code };
    this.node.getUserBy(formData).pipe(takeUntil(this.destroy$)).subscribe({
      next: () => {
        this.codeValid = true;
        this.loading = false;
      },
      error: () => {
        this.resetError = "Il link di recupero non è valido o è scaduto. Richiedi un nuovo link dalla pagina di login.";
        this.loading = false;
      },
    });
  }
}
